import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';
// import Qs from 'qs';
// eslint-disable-next-line import/prefer-default-export
/**
 * 获取机构列表
 * @param params{}
 * */
export const fetchOrganList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/manage/organ/organ/findList`,
            {
                ...params,
            },
            {
                ...config,
            },
        ),
    );
/**
 * 获取地块列表
 * @param params{code 地块编号,name 地块名称,type 地块类型,landStatus 地块状态}
 * */
export const fetchLandList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/findList`, {
            params,
            ...config,
        }),
    );
/**
 * 获取地块列表总数
 * @param params{code 地块编号,name 地块名称,type 地块类型,landStatus 地块状态，page,rows,}
 * */
export const fetchLandPageTotal = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/findPageTotal`, {
            params,
            ...config,
        }),
    );
/**
 * 获取地块列表(分页方式)
 * @param params{code 地块编号,name 地块名称,type 地块类型,landStatus 地块状态，page,rows,}
 * */
export const fetchLandPageList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/findPageList`, {
            params,
            ...config,
        }),
    );
/**
 * 获取地块列表(图册模式分页方式)
 * @param params{code 地块编号,name 地块名称,type 地块类型,landStatus 地块状态，page,rows,}
 * */
export const fetchLandPicturePageList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/findPictureList`, {
            params,
            ...config,
        }),
    );
/**
 * 获取地块图册列表
 * @param id 地块Id
 * */
export const fetchLandAtlas = (id) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/findPictureById`, {
            params: { id },
            ...config,
        }),
    );
/**
 * 根据id获取地块详情
 * @param id
 * */
export const fetchLandDetailById = (id) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/getById`, {
            params: {
                id,
            },
            ...config,
        }),
    );
/**
 * 统计土地面积
 * @param params{}
 * */
export const fetchCountArea = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/countArea`, {
            params,
            ...config,
        }),
    );
/**
 * 统计土地类型数量
 * @param params{}
 * */
export const fetchCountLandByType = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/countTypeNum`, {
            params,
            ...config,
        }),
    );
/**
 * 统计无人机巡次数
 * @param params{}
 * */
export const fetchFlyCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/land/countFlightSorties`, {
            params,
            ...config,
        }),
    );
/**
 * 统计整改数量
 * @param params{type:}TD:国储土地 GC重大工程 SZ水质 DQ大气TS投诉QT其他
 * */
export const fetchRectifyCount = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/rectify/countRectifyInfo`, {
            params,
            ...config,
        }),
    );
/**
 * 查询整改列表
 * @param params{code 整改编号,type 业务类型,businessId 业务ID} type的值说明TD:国储土地 GC重大工程 SZ水质 DQ大气TS投诉QT其他
 * */
export const fetchRectifyList = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/disc/rectify/findList`, {
            params,
            ...config,
        }),
    );
